function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function ($) {
  /**
   * Make a merge tag in any content be dynamically change on load and on input value change.
   * Aadd merge tags inside its title, content, description, etc.
   * The merge tag may look like :
   *   - {107} (Just the field ID)
   *   - {107:Name} (ID + a default until there is a value in the field)
   *   - {107.2} (ID of a subfield)
   */
  var Dynamic_Merge_Tag_Fill = /*#__PURE__*/function () {
    "use strict";

    /**
     * 
     * @param {node} field Any one Gravity Form field HTML node.
     */
    function Dynamic_Merge_Tag_Fill(field) {
      _classCallCheck(this, Dynamic_Merge_Tag_Fill);
      this.field = field;
      this.merge_tags = null;
      this.find_replace_set_merge_tags();
      if (this.merge_tags) {
        this.init_merge_tags_fill_event_and_init_content();
      }
    }
    return _createClass(Dynamic_Merge_Tag_Fill, [{
      key: "find_replace_set_merge_tags",
      value: function find_replace_set_merge_tags() {
        var _this = this;
        this.field.innerHTML = this.field.innerHTML.replace(/\{([\d\.]+)\:?([^:{}]*)\}/g, '<span class="merge-tag-filled" data-field-id="$1">$2</span>');
        var merge_tags = this.field.querySelectorAll('.merge-tag-filled');
        if (!merge_tags.length) {
          // BAIL, no merge tags here.
          return;
        }
        this.merge_tags = {};
        merge_tags.forEach(function (el) {
          var field_id = el.dataset.fieldId;
          if ('undefined' === typeof _this.merge_tags[field_id]) {
            _this.merge_tags[field_id] = [];
          }
          _this.merge_tags[field_id].push(el);
        });
      }
    }, {
      key: "init_merge_tags_fill_event_and_init_content",
      value: function init_merge_tags_fill_event_and_init_content() {
        var _this2 = this;
        for (var field_id in this.merge_tags) {
          var $input = $(this.field).parents('form').find("[name=\"input_".concat(field_id, "\"]"));
          if (!$input.length) {
            // CONTINUE, that field as no such input.
            continue;
          }

          // Save the field ID for use in event.
          $input.attr('data-field-id', field_id);

          // Change content on init, but only if there is a value.
          if ('' !== $input.val()) {
            this.change_merge_tag_content_by_input($input[0]);
          }

          // Change content on event `change`
          $input.on('change', function (event) {
            _this2.change_merge_tag_content_by_input(event.target);
            var field_id = event.target.dataset.fieldId;
            if ('undefined' !== typeof _this2.merge_tags[field_id]) {
              _this2.merge_tags[field_id].forEach(function (el) {
                return el.innerHTML = event.target.value;
              });
            }
          });
        }
      }
    }, {
      key: "change_merge_tag_content_by_input",
      value: function change_merge_tag_content_by_input(input) {
        var field_id = input.dataset.fieldId;
        if ('undefined' !== typeof this.merge_tags[field_id]) {
          this.merge_tags[field_id].forEach(function (el) {
            return el.innerHTML = input.value;
          });
        }
      }
    }]);
  }();
  $(document).on('gform_post_render', function (event, form_id, current_page) {
    $("#gform_wrapper_".concat(form_id, " .dynamic-merge-tag-fill")).each(function () {
      new Dynamic_Merge_Tag_Fill(this);
    });
  });
})(jQuery);